import { collection, getDocs } from "firebase/firestore";
import { db } from "@/firebase/config";

export interface Testimonial {
  id: string;
  name: string;
  writeup: string;
  image: string;
  occupation?: string;
}

/**
 * Fetches testimonials from Firebase Firestore
 * @returns Promise<Testimonial[]> Array of testimonials
 */
export const fetchTestimonials = async (): Promise<Testimonial[]> => {
  try {
    const testimonialsRef = collection(db, "Testimonials");
    const snapshot = await getDocs(testimonialsRef);

    const testimonials: Testimonial[] = [];
    snapshot.forEach((doc) => {
      const data = doc.data();
      testimonials.push({
        id: doc.id,
        name: data.name || "Anonymous",
        writeup: data.writeup || "",
        image: data.image || "",
        occupation: data.occupation || undefined,
      });
    });

    return testimonials;
  } catch (error) {
    console.error("Error fetching testimonials:", error);
    throw new Error("Failed to fetch testimonials from Firebase");
  }
};

/**
 * Default fallback testimonials for when Firebase is unavailable
 */
export const defaultTestimonials: Testimonial[] = [
  {
    id: "default-1",
    name: "Priya Sharma",
    writeup:
      "Cittasya® has transformed my sleep quality. The guided Yoga Nidra sessions help me release the day's stress and find deep rest.",
    image:
      "https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=60&h=60&fit=crop&crop=face",
    occupation: "Software Engineer",
  },
  {
    id: "default-2",
    name: "Arjun Mehta",
    writeup:
      "As someone with anxiety, these practices have been life-changing. The ancient wisdom delivered through modern technology is beautiful.",
    image:
      "https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=60&h=60&fit=crop&face",
    occupation: "Teacher",
  },
  {
    id: "default-3",
    name: "Kavya Reddy",
    writeup:
      "The depth of relaxation I achieve with Yoga Nidra is unmatched. It's become an essential part of my wellness routine.",
    image:
      "https://media.istockphoto.com/id/1095831130/photo/pensive-indian-woman-wears-saree-clothes.jpg?s=1024x1024&w=is&k=20&c=0dZbOp3-WDQHBRbCjVEcajpaZwdar3P1Gai7KwOml3E=",
    occupation: "Marketing Manager",
  },
];
